import { motion } from "motion/react";
import { TICKER_CONFIG } from "@/constants/animations";

interface AnimatedTickerProps {
  items?: string[];
  duration?: number;
  className?: string;
}

/**
 * Ticker animado con scroll infinito
 * Muestra preguntas frecuentes o mensajes importantes
 */
export function AnimatedTicker({ 
  items = TICKER_CONFIG.items,
  duration = TICKER_CONFIG.duration,
  className = "",
}: AnimatedTickerProps) {
  return (
    <div className={`relative overflow-hidden py-4 my-8 ${className}`}>
      {/* Gradientes de desvanecimiento en los bordes */}
      <div className="absolute left-0 top-0 bottom-0 w-24 bg-gradient-to-r from-[#edf8f8] to-transparent z-10 pointer-events-none" />
      <div className="absolute right-0 top-0 bottom-0 w-24 bg-gradient-to-l from-[#edf8f8] to-transparent z-10 pointer-events-none" />

      <motion.div
        className="flex items-center gap-12 whitespace-nowrap"
        animate={{ x: ["0%", "-50%"] }}
        transition={{
          duration,
          repeat: Infinity,
          ease: "linear",
          repeatType: "loop",
        }}
      >
        {/* Duplicamos los items para crear el efecto infinito */}
        {[...items, ...items].map((item, i) => (
          <span
            key={i}
            className="inline-flex items-center gap-3 text-[#2C5AA0] font-bold text-[16px]"
          >
            <span className="w-2 h-2 bg-[#39B5BF] rounded-full shrink-0" />
            {item}
          </span>
        ))}
      </motion.div>
    </div>
  );
}
